export default "__VITE_PUBLIC_ASSET__72c2a256__"